/* Blog Template 2026 — table of contents

   Heading IDs are generated server-side in Liquid and passed here as an
   ordered array. We assign them positionally to the h2 elements in the
   rendered body, which guarantees the TOC hrefs and the heading ids always
   match without re-implementing Liquid's handleize filter in JS.

   Two TOC instances can exist at once (the sticky rail on desktop and the
   inline block on mobile). Both are wired up and both get scrollspy. */
(function () {
  function init() {
    var body = document.querySelector('[data-blog2026-body]');
    if (!body) return;

    var ids = [];
    try {
      ids = JSON.parse(body.getAttribute('data-heading-ids') || '[]');
    } catch (e) {
      ids = [];
    }

    var headings = Array.prototype.slice.call(body.querySelectorAll('h2'));
    headings.forEach(function (h, i) {
      if (ids[i] && !h.id) h.id = ids[i];
    });

    var tocs = Array.prototype.slice.call(document.querySelectorAll('[data-blog2026-toc]'));
    if (!tocs.length) return;

    /* Collapse toggle on the inline TOC */
    tocs.forEach(function (toc) {
      var toggle = toc.querySelector('[data-blog2026-toc-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        var collapsed = toc.getAttribute('data-collapsed') === 'true';
        toc.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
        toggle.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
        toggle.textContent = collapsed ? 'Hide' : 'Show';
      });
    });

    var links = [];
    tocs.forEach(function (toc) {
      links = links.concat(Array.prototype.slice.call(toc.querySelectorAll('a[href^="#"]')));
    });
    if (!links.length || !('IntersectionObserver' in window)) return;

    /* One id can map to several links (rail + inline), so keep a list */
    var byId = {};
    links.forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      if (!byId[id]) byId[id] = [];
      byId[id].push(a);
    });

    var order = headings.map(function (h) { return h.id; });
    var visible = [];

    function setActive(id) {
      links.forEach(function (a) { a.classList.remove('is-active'); });
      (byId[id] || []).forEach(function (a) { a.classList.add('is-active'); });
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var id = entry.target.id;
        var idx = visible.indexOf(id);
        if (entry.isIntersecting && idx === -1) {
          visible.push(id);
        } else if (!entry.isIntersecting && idx !== -1) {
          visible.splice(idx, 1);
        }
      });

      if (!visible.length) return;

      var first = visible.slice().sort(function (a, b) {
        return order.indexOf(a) - order.indexOf(b);
      })[0];

      setActive(first);
    }, { rootMargin: '-100px 0px -65% 0px', threshold: 0 });

    headings.forEach(function (h) {
      if (h.id) observer.observe(h);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
